module.exports = __webpack_public_path__ + "static/media/BigBookMathIcon.f3916430.svg";